import React, { useState, useRef, useEffect,useContext } from 'react';
import { DayPicker } from 'react-day-picker';
import { ptBR } from 'date-fns/locale'; // 👈 Importa o idioma
import 'react-day-picker/style.css';
import './custom-calendar.css';
import styled from 'styled-components';
import { RequestsContext } from '../../context/requests';
import { FilterSallesContext } from '../../context/filterSalles';
import calendarIcon from '../../images/svg/calendar 1.svg'

const CardWrapper = styled.div`
  margin-top: 0.5rem;
  padding-left: 0.9rem;
`
const Input = styled.input`
  text-indent: 20px;
  border:none;
  border: 1px solid black;
  color:black;
  width:95px;
  height:35px;
  font-family: "Poppins";
  font-weight: 500;
  font-size: 0.9rem;
`
const BoxInput = styled.div`
  position: relative;
`
const ImageCalendar = styled.img`
  position: absolute;
  left: 7px;
  top: 10px;
  width:16px;

`
const Button = styled.button`
  font-family: "Poppins";
  font-weight: 500;
  border-radius:19px;
  border: none;
  width: 91px;
  font-size: 0.9rem;
  height: 31.6px;
  color: white;
  margin-top: 1.1rem;
  margin-bottom: 0.5rem;
  background-color: #0050dc;
`
function BasicDatePicker() {
  const {setTypeFilter,setUniqDayFilter,getByUniqDate} = useContext(RequestsContext)
  const {option} = useContext(FilterSallesContext)
  
  const [selected, setSelected] = useState(new Date());
  const [showPicker, setShowPicker] = useState(false);
  const pickerRef = useRef();

  useEffect(() => {

  }, [])

  useEffect(() => {
    function handleClickOutside(event) {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowPicker(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <CardWrapper ref={pickerRef} style={{ position: "relative", display: "inline-block" }}>

      <BoxInput>
        <Input
          type="text"
          readOnly
          value={selected ? selected.toLocaleDateString('pt-BR') : ''}
          onClick={() => setShowPicker(!showPicker)}
          placeholder="Selecione uma data"
          style={{
            padding: '8px',
            width: '200px',
            cursor: 'pointer',
            borderRadius: '6px',
          }}
        />
        <ImageCalendar src={calendarIcon} />

      </BoxInput>
      {showPicker && (
        <div
          style={{
            position: "absolute",
            zIndex: 100,
            background: "transparent",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
          }}
        >
          <DayPicker
            mode="single"
            selected={selected}
            onSelect={(date) => {
              setSelected(date);
              localStorage.setItem("@DATE_UNIQ_DATE_FILTER",date)
              setUniqDayFilter(date);
              setShowPicker(false);
              setTypeFilter("por data");
            }}
            locale={ptBR} // 👈 Define o idioma aqui
            className="custom-calendar"
          />
        </div>
      )}
      <Button onClick={() => getByUniqDate(option)}>aplicar</Button>

    </CardWrapper>
  );
}

export default BasicDatePicker;
